export default "__VITE_ASSET__QulhAMgV__"